/**
 * MainMenu
 *
 * The title screen. Renders nav buttons, date, and countdown timer.
 * Extracted from App.js lines 778–824.
 *
 * Props:
 *   hasPlayedToday {boolean}  - Disables the fishing button if true.
 *   user           {object}   - Firebase user object (or null for guest).
 *   todayStr       {string}   - Today's date string, e.g. "2026-03-31".
 *   timeLeft       {string}   - Countdown string, e.g. "04:22:10".
 *   onStartFishing {function} - Called when START FISHING is clicked.
 *   onLogin        {function} - Called when LOG IN is clicked.
 *   onLogout       {function} - Called when LOGOUT is clicked.
 *   onNavigate     {function} - Called with a view string to change screens.
 */

export default function MainMenu({
  hasPlayedToday,
  user,
  todayStr,
  timeLeft,
  onStartFishing,
  onLogin,
  onLogout,
  onNavigate,
}) {
  const menuButtonStyle = {
    padding: '18px',
    width: '100%',
    maxWidth: '280px',
    backgroundColor: 'transparent',
    color: 'white',
    border: '2px solid #30363d',
    borderRadius: '4px',
    fontFamily: 'inherit',
    fontSize: '12px',
    cursor: 'pointer',
    marginBottom: '15px',
    transition: 'all 0.2s ease',
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', zIndex: 1, width: '100%' }}>
      
      <h1 style={{ marginBottom: '40px', fontSize: '45px', color: '#1f6feb', textShadow: '3px 3px #000', textAlign: 'center', lineHeight: '1.25' }}>
        DAILY<br />FISHLE
      </h1>

      <button
        className="menu-btn"
        onClick={onStartFishing}
        disabled={hasPlayedToday}
        style={menuButtonStyle}
      >
        {hasPlayedToday ? 'COME BACK TOMORROW' : 'START FISHING'}
      </button>

      <button
        className="menu-btn"
        style={menuButtonStyle}
        onClick={user ? onLogout : onLogin}
      >
        {user ? `LOGOUT (${user.displayName?.split(' ')[0].toUpperCase() || 'USER'})` : 'LOG IN'}
      </button>

      <button
        className="menu-btn"
        onClick={() => onNavigate('inventory')}
        style={menuButtonStyle}
      >
        INVENTORY
      </button>

      <button
        className="menu-btn"
        onClick={() => onNavigate('directory')}
        style={menuButtonStyle}
      >
        DIRECTORY
      </button>

      <button
        className="menu-btn"
        style={menuButtonStyle}
        onClick={() => onNavigate('shop')}
      >
        SHOP
      </button>

      <div style={{ marginTop: '30px', color: '#8b949e', fontSize: '8px', textTransform: 'uppercase' }}>
        DAILY PUZZLE • {new Date(todayStr + 'T00:00:00').toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
      </div>
      <div style={{ marginTop: '5px', color: '#8b949e', fontSize: '8px', textTransform: 'uppercase' }}>
        NEXT PUZZLE IN: {timeLeft}
      </div>

      {/* Feedback Footer */}
      <a
        href="mailto:dailyfishle@gmail.com"
        style={{
          marginTop: '24px',
          color: '#8b949e',
          fontSize: '7px',
          textTransform: 'uppercase',
          letterSpacing: '1px',
          textDecoration: 'none',
          transition: 'color 0.15s ease',
        }}
        onMouseEnter={e => { e.target.style.color = '#d8dee4'; }}
        onMouseLeave={e => { e.target.style.color = '#8b949e'; }}
      >
        GOT FEEDBACK? EMAIL DAILYFISHLE@GMAIL.COM
      </a>
    </div>
  );
}